export default __webpack_public_path__ + "static/media/d56467651f917f25.7c973182b00f05a46bc7fea3cbf0d77f.svg";